import { render } from "./BotPressChat.vue?vue&type=template&id=725b5d7a"
import script from "./BotPressChat.vue?vue&type=script&lang=js"
export * from "./BotPressChat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__